import { render, staticRenderFns } from "./DefaultView.vue?vue&type=template&id=2be0f3bf&scoped=true&"
import script from "./DefaultView.vue?vue&type=script&lang=js&"
export * from "./DefaultView.vue?vue&type=script&lang=js&"
import style0 from "./DefaultView.vue?vue&type=style&index=0&id=2be0f3bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be0f3bf",
  null
  
)

export default component.exports